import * as React from 'react';

import * as styles from './ModalHeader.css';

export const ModalHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['modal-header']}>{children}</div>;
};
